// Constants
import SIWC from "components/Stacker/constants/StackItWithConstants"
import PDC from "components/Stacker/constants/ProductDetailPageConstants"

// Utils
import ApiUtils from "components/Stacker/api"

export const getProductStackList = (options) => (dispatch) => {
  dispatch({
    type: SIWC.STACK_IT_GET_PRODUCT_STACK,
  })

  ApiUtils.makeAjaxRequest(
    {
      url: "/.api.product.stack.json",
      queryParams: {
        ...options,
      },
    },
    (res) => {
      if (res.status === ApiUtils.RESPONSE_SUCCESS) {
        dispatch({
          type: SIWC.STACK_IT_RESPONSE_SUCCESS,
          payload: res,
        })
      } else {
        dispatch({
          type: SIWC.STACK_IT_RESPONSE_FAILED,
          payload: res.errorMessage,
        })
      }
    },
    (err) => {
      dispatch({
        type: SIWC.STACK_IT_RESPONSE_FAILED,
        payload: err,
      })
    }
  )
}

export const getProductStackDetails = (args) => (dispatch) => {
  dispatch({
    type: SIWC.STACK_IT_GET_PRODUCT_STACK_DETAILS,
  })

  const { baseProductCodes, selectedStackedCodes, baseStore } = args
  ApiUtils.makeAjaxRequest(
    {
      url: "/.api.product.stack.detail.json",
      queryParams: {
        productCode: baseProductCodes,
        baseStore,
      },
    },
    (res) => {
      if (res) {
        dispatch({
          type: PDC.PRODUCT_DETAIL_SUCCEED,
          payload: { res, selectedStackedCodes, isStackedProducts: true },
        })
      }
    },
    (err) => {
      dispatch({
        type: SIWC.STACK_IT_PRODUCT_DETAIL_RESPONSE_FAILED,
        payload: err,
      })
    }
  )
}

export const updateSelectedStackInfo = (options) => {
  return {
    type: SIWC.STACK_IT_SET_SELECTED_STACK,
    payload: options,
  }
}

export const resetStackIt = () => {
  return {
    type: SIWC.STACK_IT_RESET,
  }
}
export const destroyStackItModal = () => {
  return {
    type: SIWC.STACK_IT_DESTROY_MODAL,
  }
}

export const setSelectedStackedCodes = (stackedCodes) => {
  return {
    type: SIWC.STACK_IT_SET_SELECTED_STACKED_CODES,
    payload: stackedCodes,
  }
}

export const setStackedMetal = (options) => {
  return {
    type: SIWC.SET_SELECTED_STACK_METAL,
    payload: options,
  }
}

export const setNeedStackedPDPData = (options) => {
  return {
    type: SIWC.STACK_IT_WITH_SET_NEED_PDP_DATA,
    payload: options,
  }
}
